<template>
  <component :is="layout">
    <div class="error-page-padding">
      <v-img
        width="400"
        src="@/assets/rcrms.svg"
        contain
        class="fill-height mt-3"
      ></v-img>
      <v-row class="">
        <v-col cols="12">
          <v-row align="center">
            <v-col cols="6">
              <div class="display-3 mt-5 blue-grey--text font-weight-bold">
                {{ statusCode && config[statusCode].warning }}
              </div>
              <div class="mt-7 headline blue-grey--text--text">
                {{ statusCode && config[statusCode].message }}
              </div>
            </v-col>
            <v-col cols="6" align="right"
              ><v-img
                class="fill-height"
                :src="
                  statusCode
                    ? require(`@/static/images/info/${statusCode}.svg`)
                    : '@/static/images/info/404.svg'
                "
              ></v-img
            ></v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="">
          <v-btn @click="$router.go(-1)" class="mt-12 subtitle-1" large>
            Go Back
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </component>
</template>
<script>
export default {
  props: {
    statusCode: {
      type: Number,
      default: null
    },
    message: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      layout: this.$rhrCoreShellOptions.layouts.DefaultLayout,
      config: {
        "403": {
          warning: "Access Denied",
          message: "You don't have permission to access."
        },
        "404": {
          warning: "Page Not Found",
          message: "Seems like there is nothing here"
        },
        "500": {
          warning: "Something Went Wrong",
          message: "The server is not responding. Please be patient."
        },
        "410": {
          warning: "Page Removed",
          message: "The requested page has been permanently deleted"
        },
        "400": {
          message: "Bad request"
        }
      }
    };
  }
};
</script>
<style lang="sass" scoped>
.error-page-padding
  padding: 5px 40px 5px 40px
</style>
